import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-loading-value',
  template: `
    <ng-container *ngIf="!loading; else loadingTpl">
      <span [innerHTML]="value"></span>
    </ng-container>
    <ng-template #loadingTpl>
      <i class="far fa-spin fa-spinner"></i>
    </ng-template>
  `,
  styles: [
    `
      .spinner {
        display: inline-block;
        vertical-align: middle;
      }
    `,
  ],
})
export class LoadingValueComponent {
  @Input() value: any
  @Input() loading = false
}
